import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Consent } from "./getConsentSummaryForCandidate";

export interface EndConsentResponse extends BackendResponse {
  item: Consent;
}
export interface EndConsentParameters extends NextApiParams {
  consentType: number;
}

export const endConsentForCandidate = withNextApi<
EndConsentResponse,
EndConsentParameters
>("/cvp/CvpWithdrawConsent");
